'use strict'

import config from './../../configuration'
import Axios from 'axios';


const url = config.apiHost;

export default class GroupService {

  static async getAll() {
    try {
     
      let groups = await Axios.get(url + "groups");
      return groups.data.result;
    } catch (error) {
      console.log(error)
      throw error.response.data;
    }
  } // getAll()

  static async save(group) {
    try {
      let groupSaved = await Axios.post(url + "groups", group);
      return groupSaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(group) {
    try {
      let groupUpdated = await Axios.put(url + "groups", group);
      return groupUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(group) {
    try {
      await Axios.delete(url + "groups", {
        data: group
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/GroupService.js